import { Typography } from "@kelp-dao/kernel-design-system";
import Tooltip from "@components/Tooltip";

const AirdropVaultTooltip = () => {
  return (
    <Tooltip
      placement="top"
      label={
        <div>
          <Typography type="body" variant="xsmall">
            7 day trailing APR
          </Typography>
          {/* <Typography type="body" variant="xsmall">Estimated Airdrop rewards - 2.32%</Typography> */}
          <Typography type="body" variant="xsmall">
            Additional Airdrops - Kelp Miles, Infra Points
          </Typography>
          <Typography type="body" variant="xsmall" className="font-normal">
            Check <strong>&apos;Strategy Reports&apos;</strong> for details
          </Typography>
        </div>
      }
    />
  );
};

export default AirdropVaultTooltip;
